import { Component } from '@angular/core';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { ActivatedRoute } from '@angular/router';
import { AppInsightsService } from 'src/app/_services/ReportServices/app-insights.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-un-authorized',
    templateUrl: './un-authorized.component.html',
    styleUrl: './un-authorized.component.css',
    standalone: false
})
export class UnAuthorizedComponent {
  constructor() { }

  ngOnInit() {
  }

}


